// Client-only helpers for PDF downloads and safe filenames.
export const getSafeFilename = (s?: string, fallback = 'download.pdf') => (s || fallback).replace(/[^\w.\-() ]+/g, '_');

export const readFilenameFromHeaders = (resp: Response, fallback?: string) => {
  const cd = resp.headers.get('content-disposition') || '';
  const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
  try {
    const raw = m?.[1] ? decodeURIComponent(m[1]) : undefined;
    return getSafeFilename(raw || fallback);
  } catch {
    return getSafeFilename(fallback);
  }
};

/**
 * Force a download by fetching the resource as a Blob and triggering an <a download>.
 * Falls back to opening the URL in a new tab if blocked or CORS-restricted.
 */
export async function forceDownload(url: string, hintName?: string) {
  try {
    const resp = await fetch(url, { mode: 'cors', credentials: 'omit' });
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
    const blob = await resp.blob();
    const name =
      readFilenameFromHeaders(resp, hintName || url.split('/').pop() || 'file.pdf') || hintName || 'file.pdf';
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
    return false;
  }
}
